import { render, staticRenderFns } from "./PosSync.vue?vue&type=template&id=d8d5302a"
import script from "./PosSync.vue?vue&type=script&lang=ts"
export * from "./PosSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports